// extracted by mini-css-extract-plugin
export default {"root":"ExaminationFilling_root__yg5q7"};